// @ts-nocheck

import React, { useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import NavigationTabBar from './NavigationTabBar';
import selectNavigationTabBarProps from './NavigationTabBar.selector';

const StyledTabBar = styled(NavigationTabBar)`
  position: fixed;
  bottom: 0;
  left: 0;

  height: var(--tabbar-height);

  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
`;

const NavigationTabBarContainer = () => {
  const {
    history: h,
    location: { pathname },
  } = useRouter();
  const d = useDispatch();
  const historyRef = useRef(h);
  const dispatchRef = useRef(d);

  const selectorProps = useMemo(
    () => ({ history: historyRef.current, pathname, dispatch: dispatchRef.current }),
    [pathname],
  );
  const selectedProps = useSelector((state) => selectNavigationTabBarProps(state, selectorProps));

  const enhancedProps = useMergeProps({ selectedProps });

  return <StyledTabBar {...enhancedProps} />;
};

export default NavigationTabBarContainer;
